import { useContext } from 'react';
import clsx from 'clsx';

import WorkTemplateContext, {
  WorkTemplateView,
} from '@atom/components/workTemplate/WorkTemplateContext';
import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './workTemplateHeader.module.css';

export interface Props {
  view: {
    value: WorkTemplateView;
    label: string;
    icon: any;
  };
}

const WorkTemplateHeaderButton = ({ view }: Props) => {
  const { activeView, setActiveView } = useContext(WorkTemplateContext);

  return (
    <div
      onClick={() => setActiveView(view.value)}
      className={clsx(
        classes.iconContainer,
        activeView === view.value && classes.active,
      )}
    >
      <div className={classes.icon}>
        <Icon color={colors.neutral.white} children={view.icon} />
      </div>
      <div className={classes.label}>{view.label}</div>
    </div>
  );
};

export default WorkTemplateHeaderButton;
